// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.head-element {
  display: flex;
  align-items: start;
  gap: 1em;
}
.head-element span:first-child {
  width: 20%;
  margin-right: 1rem;
  white-space: nowrap;
}
.head-element span:nth-child(2) {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.head-element button {
  flex-shrink: 0;
}

.description-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
}

.description-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.description-text {
  flex: 1;
  white-space: normal;
  word-wrap: break-word;
  overflow: hidden;
}

.description-row button {
  flex-shrink: 0;
}

.technical-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.technical-toggle button {
  transition: transform 0.3s ease;
}
.technical-toggle button.expanded {
  transform: rotate(180deg);
}

.technical-toggle small {
  color: grey;
}

.edit {
  margin-top: 2rem;
}

.edit-element {
  display: flex;
  align-items: center;
  gap: 3em;
  margin-bottom: 1rem;
}
.edit-element span:first-child {
  width: 20%;
  font-weight: bold;
  align-self: flex-start;
}

.description-input {
  height: 6rem;
  padding: 0.5rem;
  resize: vertical;
}

.actions-wrapper {
  margin-top: 2rem;
}

.header {
  display: flex;
  justify-content: space-between;
  margin: 0 auto 1em;
}
.header h2 {
  margin: 0;
}
@media screen and (max-width: 780px) {
  .header {
    align-items: flex-start;
    flex-direction: column-reverse;
  }
  .header .header-buttons {
    margin: 1rem 0;
  }
}

.checkboxReactForm {
  border: 2px solid #ced4da;
  background: #ffffff;
  width: 20px;
  height: 20px;
  color: #495057;
  border-radius: 3px;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.field-list {
  display: flex;
  flex-direction: column;
  gap: 0rem;
  margin-top: 1rem;
}

.field-item {
  display: flex;
  flex-direction: column;
  gap: 0rem;
}

.end-button-style {
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
  margin-top: 2rem;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 1rem;
  margin-bottom: 2rem;
}

.inline-edit-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.inline-input,
.inline-textarea {
  flex: 1;
  font: inherit;
  padding: 0.3rem 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
}

.inline-actions {
  display: flex;
  gap: 0.5rem;
}

.technical-join-view {
  margin: 1rem 0 1rem calc(20% + 2rem);
  padding: 1rem;
  background-color: var(--surface-100, #f8f9fa);
  border-radius: 4px;
  border-left: 2px solid var(--tj-primary-300);
}
.technical-join-view .join-tree ::ng-deep .p-treenode-content {
  padding: 0.35rem 0.5rem;
  border-radius: 4px;
}
.technical-join-view .join-tree ::ng-deep .p-treenode-content:hover {
  background-color: rgba(59, 130, 246, 0.08);
}
.technical-join-view .join-tree ::ng-deep .p-treenode-children {
  margin-left: 1.25rem;
  padding-left: 0.5rem;
}
.technical-join-view .join-node {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin: 0.25rem 0;
}
.technical-join-view .join-node .join-condition {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  flex-wrap: wrap;
}

.hover-container .hover-edit-btn {
  opacity: 0;
  transition: opacity 0.2s ease;
}
.hover-container:hover .hover-edit-btn {
  opacity: 1;
}

.inline-labels {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.inline-label-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.inline-label-lang {
  min-width: 1.75rem;
  font-weight: 600;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/view-editor/view-item-editor/view-item-editor.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,QAAA;AACJ;AACI;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;AACN;AAEI;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAN;AAGI;EACE,cAAA;AADN;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAFF;;AAKA;EACE,OAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAFF;;AAKA;EACI,+BAAA;AAFJ;AAGI;EACA,yBAAA;AADJ;;AAKA;EACE,WAAA;AAFF;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAFJ;AAII;EACI,UAAA;EACA,iBAAA;EACA,sBAAA;AAFR;;AAMA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;AAHJ;AAKI;EACI,SAAA;AAHR;AAMI;EATJ;IAUQ,uBAAA;IACA,8BAAA;EAHN;EAKM;IACI,cAAA;EAHV;AACF;;AAQA;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iFAAA;AALJ;;AASA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AANJ;;AASA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AANJ;;AASA;EACI,aAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;AANJ;;AASA;EACI,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AANJ;;AASA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AANJ;;AASE;;EAEE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;AANJ;;AASE;EACE,aAAA;EACA,WAAA;AANJ;;AASA;EACI,oCAAA;EACA,aAAA;EACA,6CAAA;EACA,kBAAA;EACA,4CAAA;AANJ;AAUQ;EACE,uBAAA;EACA,kBAAA;AARV;AAUU;EACE,0CAAA;AARZ;AAYQ;EACE,oBAAA;EACA,oBAAA;AAVV;AAeI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAbN;AAeM;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAbR;;AAmBE;EACE,UAAA;EACA,6BAAA;AAhBJ;AAmBE;EACE,UAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,gBAAA;AAlBF;AACA,4xPAA4xP","sourcesContent":[".head-element {\n    display: flex;\n    align-items: start;\n    gap: 1em;\n\n    span:first-child {\n      width: 20%;\n      margin-right: 1rem;\n      white-space: nowrap;\n  }\n  \n    span:nth-child(2) {\n      flex: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  \n    button {\n      flex-shrink: 0;\n    }\n}\n\n.description-container {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n}\n\n.description-row  {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n}\n\n.description-text {\n  flex: 1;\n  white-space: normal;\n  word-wrap: break-word;\n  overflow: hidden;\n}\n\n.description-row button {\n  flex-shrink: 0;\n}\n\n.technical-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.technical-toggle button {\n    transition: transform 0.3s ease;\n    &.expanded {\n    transform: rotate(180deg);\n     }\n}\n\n.technical-toggle small {\n  color: grey;\n}\n\n.edit {\n    margin-top: 2rem;\n}\n\n.edit-element {\n    display: flex;\n    align-items: center;\n    gap: 3em;\n    margin-bottom: 1rem;\n\n    span:first-child {\n        width: 20%;\n        font-weight: bold;\n        align-self: flex-start;\n    }\n}\n\n.description-input {\n    height: 6rem;\n    padding: 0.5rem;\n    resize: vertical;\n}\n\n.actions-wrapper {\n    margin-top: 2rem;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    margin: 0 auto 1em;\n\n    h2 {\n        margin: 0;\n    }\n\n    @media screen and (max-width: 780px) {\n        align-items: flex-start;\n        flex-direction: column-reverse;\n\n        .header-buttons {\n            margin: 1rem 0;\n        }\n    }\n}\n\n\n.checkboxReactForm {\n    border: 2px solid #ced4da;\n    background: #ffffff;\n    width: 20px;\n    height: 20px;\n    color: #495057;\n    border-radius: 3px;\n    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n\n.field-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0rem;\n    margin-top: 1rem;\n}\n\n.field-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0rem;\n}\n\n.end-button-style {\n    display: flex;\n    flex-direction: row-reverse;\n    gap: 1rem;\n    margin-top: 2rem;\n}\n\n.actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.inline-edit-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    width: 100%;\n  }\n  \n  .inline-input,\n  .inline-textarea {\n    flex: 1;\n    font: inherit;\n    padding: 0.3rem 0.5rem;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    outline: none;\n  }\n  \n  .inline-actions {\n    display: flex;\n    gap: 0.5rem;\n  }\n\n.technical-join-view {\n    margin: 1rem 0 1rem calc(20% + 2rem);\n    padding: 1rem;\n    background-color: var(--surface-100, #f8f9fa);\n    border-radius: 4px;\n    border-left: 2px solid var(--tj-primary-300);\n\n    .join-tree {\n      ::ng-deep {\n        .p-treenode-content {\n          padding: 0.35rem 0.5rem;\n          border-radius: 4px;\n          \n          &:hover {\n            background-color: rgba(59, 130, 246, 0.08);\n          }\n        }\n\n        .p-treenode-children {\n          margin-left: 1.25rem;\n          padding-left: 0.5rem;\n        }\n      }\n    }\n    \n    .join-node {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 0.5rem;\n      margin: 0.25rem 0;\n      \n      .join-condition {\n        display: inline-flex;\n        align-items: center;\n        gap: 0.25rem;\n        flex-wrap: wrap;\n      }\n    }\n  }\n\n.hover-container {\n  .hover-edit-btn {\n    opacity: 0;\n    transition: opacity 0.2s ease;\n  }\n\n  &:hover .hover-edit-btn {\n    opacity: 1;\n  }\n}\n\n.inline-labels {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.inline-label-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.inline-label-lang {\n  min-width: 1.75rem;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
